import React from 'react';
import { MetricCard } from './MetricCard';
import { formatMsToReadable } from '../utils/formatMsToReadable';
import type { ReportMetrics } from '@/types/reports';

interface MetricsGridProps {
  metrics: ReportMetrics | null;
}

function formatIntegerDiff(d: number): string {
  return String(Math.round(d));
}

export const MetricsGrid: React.FC<MetricsGridProps> = ({ metrics }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    <MetricCard
      title="Visualizações"
      value={metrics?.views.current != null ? Math.round(metrics.views.current) : 0}
      metric={metrics?.views}
      formatDiff={formatIntegerDiff}
    />
    <MetricCard
      title="Visitantes"
      value={metrics?.visitors.current != null ? Math.round(metrics.visitors.current) : 0}
      metric={metrics?.visitors}
      formatDiff={formatIntegerDiff}
    />
    <MetricCard
      title="Tempo médio de visualização"
      value={metrics?.avgViewTimeMs ? formatMsToReadable(metrics.avgViewTimeMs.current) : '—'}
      metric={metrics?.avgViewTimeMs}
      formatDiff={formatMsToReadable}
    />
  </div>
);
